import React from 'react'
import PersistedComponent from '../../PersistedComponent'
import MobileArticleImageBox from '../../../boxes/StyledMobileArticleImageBox'
import WidgetContainer from '../../../containers/WidgetContainer'
import { ImageRow } from '../../../utils/Grid'
import ImageBoxWrapper from '../ImageBoxWrapper'
import MobileFirstImageBox from './StyledMobileFirstImageBox'
import MobileBoxesGenerator from '../../../utils/MobileBoxesGenerator'
import { type VideoWidgetProps } from '../Types'

export default class MobileVideo extends PersistedComponent {
  constructor (props: VideoWidgetProps) {
    super(props)

    this.persistedKeys.push('isOpen')

    this.state = Object.assign({ isOpen: true }, this.state)
  }

  handleToggleContent () {
    const {
      isOpen
    } = this.state

    this.setState({
      isOpen: !isOpen
    })
  }

  render () {
    const {
      props: {
        activeDynamicLayout,
        isOpening,
        widget,
        widget: {
          ad,
          boxes = [],
          imageSize,
          name,
          utmContent,
          utmMedium,
          utmSource
        }
      },
      state: {
        isOpen
      }
    } = this

    if (!boxes || !boxes.length) {
      return null
    }

    const [
      firstBox,
      ...smallBoxes
    ] = boxes

    const utmParams = {
      utmContent,
      utmMedium,
      utmSource
    }

    const renderSmallBox = (box, index) => <ImageBoxWrapper
      box={box}
      imageBoxComponent={MobileArticleImageBox}
      imageSize={imageSize}
      index={index + 1}
      key={`smallMobileVideoBox${index + 1}`}
      utmParams={utmParams}
    />

    return (
      <WidgetContainer
        activeDynamicLayout={activeDynamicLayout}
        handleToggleContent={this.handleToggleContent.bind(this)}
        isOpen={isOpen}
        isOpening={isOpening}
        widget={widget}
      >
        <ImageBoxWrapper
          box={firstBox}
          imageBoxComponent={MobileFirstImageBox}
          imageSize='16_9L'
          index={0}
          utmParams={utmParams}
        />
        <ImageRow>
          <MobileBoxesGenerator
            ad={ad}
            boxes={smallBoxes}
            device={activeDynamicLayout}
            name={name}
            renderImageBox={renderSmallBox}
          />
        </ImageRow>
      </WidgetContainer>
    )
  }
}
